<!-- The Popup Component -->
<template>
    <transition name="fade">
      <div v-if="isShow" class="popup topBk" >
       
        <div class="popup-content">
          <div class="close d-flex align-items-start" >
            <img src="../assets/icon-close.png" @click.self="handleClose">
          </div>
          <slot/>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  export default {
    data(){
      return{
        hasClose:true
      };
      
    },
    props: ["isShow"],
    mounted(){
      var token=localStorage.getItem('sessionToken');
      if(token==undefined || token==null ||token=='')
      {
        this.hasClose=false
      }
    },
    methods: {
      handleClose() {
       
        this.$emit('update:isShow', false);
      }
    }
  };
  </script>
  
  <style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s;
  }
  
  .fade-enter,
  .fade-leave-to
  /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  
  .popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;    
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .popup-content {  
    width: 80%;
    height:70%;  
    border-radius:0.2rem;
    background: #FFF;
    cursor: pointer;
   
  }

  .close{
    position: absolute;
    top:0.25rem;
    right:0.25rem;
    
  }

  </style>
  